export const ACTIVATE_HISTORICAL_TICKET = 'ACTIVATE_HISTORICAL_TICKET';
export const DEACTIVATE_HISTORICAL_TICKET = 'DEACTIVATE_HISTORICAL_TICKET';
export const CLEAR_ALL_TICKET = 'CLEAR_ALL_TICKET';
